import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import arTranslation from "./locales/ar/translation.json";

i18n
                .use(LanguageDetector)
                .use(initReactI18next)
                .init({
                                resources: {
                                                en: {
                                                                translation: enTranslation,
                                                },
                                                ar: {
                                                                translation: arTranslation,
                                                },
                                },
                                fallbackLng: "en",
                                debug: true,
                                interpolation: {
                                                escapeValue: false, // not needed for react as it escapes by default
                                },
                                detection: {
                                                order: ["localStorage", "cookie", "navigator"],
                                                caches: ["localStorage", "cookie"],
                                },
                });

export default i18n;
